<template>
<div class="modifier-field">
    <div class="modifier-field__status">
        <div
          class="modifier-field__dot modifier-field__dot--green"
          :class="{'modifier-field__dot--yellow': isYellowColor, 'modifier-field__dot--red': isRedColor}"></div>
        <div>{{statusText}}</div>
    </div>
    <div class="modifier-field__risk">{{riskText}}</div>
</div>
</template>

<script>
    export default {
        name: "UXModifierField",
        props: {
            statusText: String,
            riskText: String,
            isYellowColor: Boolean,
            isRedColor: Boolean
        },
        computed: {}
    };
</script>
